<template>
  <el-dialog :visible="detailDialogVisible" :title="'编辑项目'" width="1200px" @close="closeDialog">
     <el-form :model="editingProject" ref="form" label-width="140px">
      <el-form-item label="题目：" prop="title" required>
        <el-input 
          v-for="lang in languageList" :key="lang.value"
          :placeholder="`${lang.label}题目`" 
          :value="((editingProject || {}).title || {})[lang.value]"
          @change="handleChange('title', $event, lang.value)"
          class="input"
        ></el-input>
      </el-form-item>
      <el-form-item label="题目需要详细介绍">
        <el-checkbox v-model="needDescription"></el-checkbox>
      </el-form-item>
      <el-form-item v-if="needDescription" :label="`题目介绍（${lang.label}）：`" v-for="lang in languageList" :key="lang.value">
        <editor v-model="(editingProject || {}).description[lang.value]" class="editor"></editor>
      </el-form-item>
      <el-form-item label="选项：" prop="options" required> 
        <div v-for="(option, index) in (editingProject || {}).options || []" :key="index">
          <div>
            选项{{ index + 1 }}
            <el-button type="danger" class="remove-button" icon="el-icon-delete" circle size="small" @click="removeOption(index)"></el-button>
          </div>
          <el-input
            v-for="lang in languageList"
            :placeholder="lang.label" 
            :key="lang.value"
            :value="option.value[lang.value]"
            class="input"
            @change="handleOptionChange(index, lang.value, $event)"
          ></el-input>
        </div>
        <el-button type="success" @click="createOption" class="create-button">添加选项</el-button>
      </el-form-item>
      <el-form-item label="起止时间：" required>
        <el-col :span="7">
          <el-form-item prop="startTime">
            <el-date-picker 
              :value="editingProject.startTime" 
              @input="handleChange('startTime', $event)"
              value-format="timestamp" 
              type="datetime" 
              placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="endTime">
            <el-date-picker 
              :value="(editingProject || {}).endTime"
              @input="handleChange('endTime', $event)"
              value-format="timestamp" 
              type="datetime" 
              placeholder="选择截止时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import AnswerInput from '../answerInput';
import LANGUAGE from 'common/languages';
import Editor from 'components/editor';

const languageDtos = Object.keys(LANGUAGE).reduce(
  (obj, key) => ({
    ...obj,
    [key]: {}
  }),
  {}
);
export default {
  name: 'quizDetail',
  data() {
    return {
      needDescription: false,
      currentLang: '1'
    };
  },
  computed: {
    ...mapState('quiz', [
      'editingProject',
      'languageList',
      'detailDialogVisible'
    ]),
    disabled() {
      return this.editingProject && this.editingProject.status !== 0;
    }
  },
  components: {
    AnswerInput,
    Editor
  },
  methods: {
    ...mapMutations('quiz', ['setEditingProject', 'setDetailDialogVisible']),
    ...mapActions('quiz', ['update']),
    closeDialog() {
      this.setEditingProject({});
      this.setDetailDialogVisible(false);
      this.$refs['form'].resetFields();
    },
    handleChange(type, value, key) {
      this.setEditingProject({
        ...this.editingProject,
        [type]:
          key !== undefined
            ? { ...this.editingProject[type], [key]: value }
            : value
      });
    },
    handleOptionChange(index, key, value) {
      this.setEditingProject({
        ...this.editingProject,
        options: this.editingProject.options.map((item, idx) => {
          if (index === idx) {
            return {
              ...item,
              value: {
                ...item.value,
                [key]: value
              }
            };
          }

          return item;
        })
      });
    },
    createOption() {
      this.setEditingProject({
        ...this.editingProject,
        options: [...this.editingProject.options, { value: {} }]
      });
    },
    removeOption(index) {
      this.setEditingProject({
        ...this.editingProject,
        options: this.editingProject.options.filter(
          (item, idx) => idx !== index
        )
      });
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        valid && this.doSave();
      });
    },
    doSave() {
      this.update({
        ...this.editingProject,
        options: this.editingProject.options.map((item, index) => {
          return {
            ...item,
            id: index + 1
          };
        })
      }).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
<style lang="less" scoped>
.editor {
  height: 100px;
}

.input + .input {
  margin-top: 10px;
}

.create-button {
  margin-top: 10px;
}

.remove-button {
  margin: 10px 5px;
}
</style>

